import { VGPS, VQRVerificationRequest, VQRVerificationResponse } from '@datarock/protobuffers';
import { EncryptedEndpoint } from './Encrypted';
class QRActivateEndpoint extends EncryptedEndpoint {
    async getRequestInit({ biometricPublicKey, longitude, latitude, qrCode }) {
        const requestBytes = VQRVerificationRequest.encode({
            biometricPublicKey,
            gps: VGPS.fromJSON({
                latitude,
                longitude
            }),
            qrCode
        }).finish();
        return await super.getRequestInit(requestBytes);
    }
    async process(value, ...args) {
        const responseBytes = await super.process(value, ...args);
        return VQRVerificationResponse.decode(responseBytes);
    }
}
export const qrActivateEndpoint = new QRActivateEndpoint({
    path: '/qr/activate',
    method: 'POST',
    sideEffect: true,
    body: {},
    schema: VQRVerificationResponse
});
